const Reducer = (state, action) => {
  switch (action.type) {
    case 'DATA_LOADING':
      let params = {
        loading: true,
        error: false,
        success: false,
        message: '',
      };
      if (action?.payload) params = { ...params, ...action.payload };
      return {
        ...state,
        ...params,
      };
    case 'GET_PENDING_ACTIONS':
      return {
        ...state,
        loading: false,
        loading_actions: false,
        pendingActionData: action.payload,
      };

    case 'PENDING_ACTIONS_DIALOG':
      return {
        ...state,
        pendingActionDialog: action.payload,
      };

    default:
      return state;
  }
};

export default Reducer;
